export const columnLayout = () => {
  const gridColumnLayOut = [
    {
      dataField: "compCd",
      headerText: "회사구분",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantCd",
      headerText: "사업장구분",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantNm",
      headerText: "사업장(출발지공장)",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "wbrdgCd",
      headerText: "계근대구분",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "wbrdgNm",
      headerText: "계근대구분",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "wgtDt",
      headerText: "계근일자",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "odrType",
      headerText: "배차종류",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "odrTypeNm",
      headerText: "배차종류",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inWeighDt",
      headerText: "입차일시",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inWeight",
      headerText: "입차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outWeighDt",
      headerText: "출차일시",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "outWeight",
      headerText: "출차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "realWeight",
      headerText: "입고중량(합계)",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "rmks",
      headerText: "검수원비고",
      editable: true,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "carNo",
      headerText: "차량번호",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "carNo4",
      headerText: "차량번호",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "drivNm",
      headerText: "운전자",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivTel",
      headerText: "전화번호",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemCd",
      headerText: "사전등급",
      editable: false,
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemNm",
      headerText: "사전등급",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "poaPlantCd",
      headerText: "사업장구분",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "poaPlantNm",
      headerText: "도착지공장",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inweighdt1",
      headerText: "입차일시(도착지)",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inweight1",
      headerText: "입차중량(도착지)",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outweighdt1",
      headerText: "출차일시(도착지)",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outweight1",
      headerText: "출차중량(도착지)",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "realweight1",
      headerText: "계근중량(도착지)",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "tabUnloadCd",
      headerText: "하차지역",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tabLoadNm",
      headerText: "사내상차지",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tabUnloadNm",
      headerText: "하차지역",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "dtlOdrType",
      headerText: "상세배차종류",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dtlNm",
      headerText: "상세배차종류",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrCd",
      headerText: "공급업체 코드",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrNm",
      headerText: "공급업체(운송업체)",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "shipNm",
      headerText: "모선명",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "blNo",
      headerText: "B/L번호",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tmsInscNo",
      headerText: "배차지시번호",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tmsShmtNo",
      headerText: "출하지시번호",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "preWght",
      headerText: "이론중량",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "tabLoadCd",
      headerText: "사내상차지",
      visible: false,
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "wssId",
      headerText: "계근아이디",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tmsOdrNo",
      headerText: "배차번호",
      editable: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
  ];
  return gridColumnLayOut;
};
